export function restoreIOSPWARoute(
  replace: (url: string) => void,
) {
  const isIOSStandalone =
    typeof navigator !== 'undefined' &&
    'standalone' in navigator &&
    (navigator as Navigator & { standalone?: boolean }).standalone === true;

  if (!isIOSStandalone) return;

  const lastPath = localStorage.getItem('pwa:lastPath');
  const shouldRestore = localStorage.getItem('pwa:shouldRestore') === 'yes';

  if (
    shouldRestore &&
    history.length === 1 &&
    lastPath &&
    lastPath !== '/'
  ) {
    localStorage.setItem('pwa:shouldRestore', 'no');
    replace(lastPath);
  }
}

export function persistIOSPWARoute(pathname: string) {
  const isIOSStandalone =
    typeof navigator !== 'undefined' &&
    'standalone' in navigator &&
    (navigator as Navigator & { standalone?: boolean }).standalone === true;

  if (!isIOSStandalone) return;

  if (pathname === '/') {
    localStorage.removeItem('pwa:lastPath');
    localStorage.removeItem('pwa:shouldRestore');
  } else {
    localStorage.setItem('pwa:lastPath', pathname);
    localStorage.setItem('pwa:shouldRestore', 'yes');
  }
}
